import { render, staticRenderFns } from "./PendantPlate.vue?vue&type=template&id=b2e627e0&scoped=true&"
import script from "./PendantPlate.vue?vue&type=script&lang=js&"
export * from "./PendantPlate.vue?vue&type=script&lang=js&"
import style0 from "./PendantPlate.vue?vue&type=style&index=0&id=b2e627e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e627e0",
  null
  
)

component.options.__file = "PendantPlate.vue"
export default component.exports